import { createFileRoute, Link } from '@tanstack/react-router';
import { useThread } from '@/data/messaging';
import { ThreadView } from '@/components/messaging/ThreadView';

export const Route = createFileRoute('/parent/messages/$threadId')({
  component: ParentThread,
});

function ParentThread() {
  const { threadId } = Route.useParams();
  const thread = useThread(threadId);

  return (
    <div className="flex h-[calc(100dvh-10rem)] flex-col space-y-6">
      <header>
        <Link
          to="/parent/messages"
          className="text-[var(--color-ink-muted)] text-[var(--text-sm)] hover:text-[var(--color-ink)]"
        >
          ← Inbox
        </Link>
        <h1 className="mt-2">{thread.data?.subject ?? 'Conversation'}</h1>
      </header>

      <div className="flex-1 overflow-hidden">
        <ThreadView threadId={threadId} viewerRole="parent" />
      </div>
    </div>
  );
}
